module.exports = __webpack_public_path__ + "media/images/lp_v6_img14-b481e46095abcadee9875ac932677f13.webp";